// Critical resource preloader for improved FCP/LCP
export const preloadCriticalResources = () => {
  // STRICT desktop detection to protect mobile performance
  const isDesktop = window.innerWidth > 1024 && !('ontouchstart' in window);
  const isMobile = window.innerWidth <= 768 || 'ontouchstart' in window;

  // Base preconnects for all devices (minimal for mobile)
  const basePreconnectHints = [
    'https://api.vinspectorai.com',
    'https://auth.vinspectorai.com',
    'https://res.cloudinary.com',
  ];

  // Additional preconnects only for true desktop users
  const desktopPreconnectHints = [
    'https://js.stripe.com',
    'https://fonts.googleapis.com',
    'https://www.googletagmanager.com',
    'https://fonts.gstatic.com',
  ];

  // Apply appropriate preconnects based on device
  const preconnectHints = isMobile
    ? basePreconnectHints
    : [...basePreconnectHints, ...desktopPreconnectHints];

  preconnectHints.forEach((url) => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = url;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });

  // Preload LCP image with device-appropriate optimization
  const lcpImage = document.createElement('link');
  lcpImage.rel = 'preload';
  lcpImage.as = 'image';
  lcpImage.href = isMobile
    ? 'https://res.cloudinary.com/dtoc8w3mi/image/upload/f_auto,q_auto,w_60,h_60,dpr_auto/v1746272812/ChatGPT_Image_2025-01-26_at_7.26.43_PM_ai7rz0.png'
    : 'https://res.cloudinary.com/dtoc8w3mi/image/upload/f_auto,q_auto,w_80,h_80,dpr_auto/v1746272812/ChatGPT_Image_2025-01-26_at_7.26.43_PM_ai7rz0.png';
  lcpImage.fetchPriority = 'high';
  document.head.appendChild(lcpImage);

  // Font preloading ONLY for desktop users
  if (isDesktop) {
    const fontPreload = document.createElement('link');
    fontPreload.rel = 'preload';
    fontPreload.as = 'font';
    fontPreload.type = 'font/woff2';
    fontPreload.href =
      'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZ9hiA.woff2';
    fontPreload.crossOrigin = 'anonymous';
    document.head.appendChild(fontPreload);
  }

  // Critical CSS preload - inline for immediate rendering
  const criticalCSS = `
    .container:not(.blog-post-content):not(.mobile-full-width){max-width:100%;padding:0 15px}
    .navbar{background:#fff;box-shadow:0 2px 4px rgba(0,0,0,.1);height:56px}
    .btn{padding:.375rem .75rem;border-radius:.25rem;border:1px solid transparent}
    .main-container{min-height:100vh;padding-top:0}
    .ai-assistant-image{width:60px;height:60px;border-radius:50%}
    @media(max-width:768px){.container:not(.blog-post-content):not(.mobile-full-width){padding:0 10px}.main-container.mt-5.pt-5{margin-top:0!important;padding-top:1rem!important}}
  `;

  const style = document.createElement('style');
  style.textContent = criticalCSS;
  document.head.insertBefore(style, document.head.firstChild);
};

export default preloadCriticalResources;
